class ServiceGoogleLogin extends ServiceIndex {
    constructor() {
        super()
        this.baseUrl = '/laravel/google-login'
    }

    async status() {
        try {
            let url = `${this.baseUrl}/status`
            let response = await axios.get(url, { headers: this.headers })
            return response.data
        } catch (error) {
            this.jwtValid(error)
            console.error('fetchAPIError', error)
            return error.response && error.response.data ? error.response.data : { result: false, message: 'Não foi possível carregar o status da conta Google.' }
        }
    }

    async connect(params) {
        try {
            let url = `${this.baseUrl}/connect`
            let response = await axios.get(url, { headers: this.headers, params: params || {} })
            return response.data
        } catch (error) {
            this.jwtValid(error)
            console.error('fetchAPIError', error)
            return error.response && error.response.data ? error.response.data : { result: false, message: 'Não foi possível iniciar a vinculação com o Google.' }
        }
    }

    async disconnect() {
        try {
            let url = `${this.baseUrl}/disconnect`
            let response = await axios.post(url, {}, { headers: this.headers })
            return response.data
        } catch (error) {
            this.jwtValid(error)
            console.error('fetchAPIError', error)
            return error.response && error.response.data ? error.response.data : { result: false, message: 'Não foi possível desvincular a conta Google.' }
        }
    }

    async exchange(code) {
        try {
            let url = `${this.baseUrl}/exchange`
            let response = await axios.post(url, { code: code })
            return response.data
        } catch (error) {
            console.error('fetchAPIError', error)
            return error.response && error.response.data ? error.response.data : { result: false, message: 'Não foi possível entrar com o Google.' }
        }
    }
}
